import { InscriptionModel } from '@modules/inscription/inscription-model';

const { fields } = InscriptionModel;

export default [
    fields.name,
    fields.lastName,
    fields.picture,
    fields.uid,
    fields.teams,
];